var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOut = function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.578 3.577a.83.83 0 0 1 .589-.244H7.5a.833.833 0 0 0 0-1.666H4.167a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5H7.5a.833.833 0 0 0 0-1.666H4.167a.834.834 0 0 1-.833-.834V4.167c0-.221.087-.433.244-.59m9.166 1.667a.833.833 0 0 1 1.179 0l4.167 4.167a.833.833 0 0 1 0 1.178l-4.167 4.167a.833.833 0 0 1-1.179-1.178l2.745-2.745H7.38c-.394 0-.714-.373-.714-.833s.32-.833.714-.833h8.108l-2.745-2.744a.833.833 0 0 1 0-1.179"
  })));
};
export default SvgLogOut;